import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TitleView from 'react/views/generic/TitleView';
import CarouselItem from 'react/views/carousel/CarouselItem';

class SeriesTitle extends Component {
	setHeight() {
		if (this.props.otsEnabled) {
			if(this.props.title.lexile){
				return "270px";
			}
			return "250px";
		}
	}

	render() {
		return (
			<CarouselItem itemHeight={(this.setHeight())}>
				<TitleView {...this.props} />
			</CarouselItem>
		);
	}
}
SeriesTitle.propTypes = {
	title: PropTypes.object.isRequired,
	otsEnabled: PropTypes.bool,
	closeModal: PropTypes.func
}
export default SeriesTitle;



// WEBPACK FOOTER //
// ./src/react/views/series/SeriesTitle.jsx